import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-nicaplayer',
  templateUrl: './nicaplayer.component.html',
  styleUrls: ['./nicaplayer.component.css']
})
export class NicaplayerComponent implements OnInit {
  @Input() url = "";
  url11:string=""
  url11Flag:boolean=false
  url1="https://vimeo.com/event/1698194/embed?autoplay=1&loop=0&muted=1"
  constructor() { }

  ngOnInit() {
    this.url11=this.url;
    if(this.url11>'') this.url11Flag=true
    //alert(this.url11Flag)
  }
  public settaUrl(url){
    this.url11=this.url;
    this.url11Flag=true;
    $( '#RSIFrame').attr( 'src', url);
    //$("#RSIFrame").reload();
    //alert(url)
  }

}
